<script setup lang="ts">
import { createServiceSchema } from '~/schemas/Service';

useSeoMeta({
  ogUrl: "https://navatel.ir/products/management-dashboard/",
  ogTitle: "پنل مدیریتی نواتل | مدیریت یکپارچه ارتباطات کسب‌وکار",
  ogDescription: "با پنل مدیریتی نواتل، تجربه‌ای منحصر به‌فرد از ارتباطات یکپارچه و ابری داشته باشید و مدیریت ساده و هوشمندانه کسب‌وکار خود را تجربه کنید.",
})

useHead({
  title: "پنل مدیریتی نواتل | مدیریت یکپارچه ارتباطات کسب‌وکار",
  meta: [
    {
      name:'description',
      content: 'با پنل مدیریتی نواتل، تجربه‌ای منحصر به‌فرد از ارتباطات یکپارچه و ابری داشته باشید و مدیریت ساده و هوشمندانه کسب‌وکار خود را تجربه کنید.'
    },
    {
      name: "keywords", 
      content: "پنل مدیریتی, پنل مدیریت, داشبورد نواتل" 
    }
  ],
  link: [
    {
      rel: 'canonical',
      href: "https://navatel.ir/products/management-dashboard/"
    }
  ],
  script: [
    {
      type: 'application/ld+json',
      textContent: JSON.stringify(createServiceSchema({
        name: "پنل مدیریتی نواتل",
        alternateName: "Management Dashboard",
        type: "Cloud Management Dashboard",
        description: "با پنل مدیریتی مرکز تلفن ابری نواتل، در هر زمان و هر مکان می توانید تنظیمات دلخواهتان را برای تماس ها اعمال نموده و گزارش مرکز تلفن خود را مشاهده نمایید.",
        url: "https://navatel.ir/products/management-dashboard/",
        img: "/img/features/management.webp"
      }))
    },
  ],
})

const topCardDetails = {
  title: "پنل مدیریتی نواتل، اتاق فرمان هوشمند شما",
  desc: `با پنل مدیریتی مرکز تلفن ابری نواتل، در هر زمان و هر مکان می توانید تنظیمات دلخواهتان را برای تماس ها اعمال نموده و گزارش مرکز تلفن خود را مشاهده نمایید.`,
  firstButton: { text: "دمو و مشاوره رایگان", modalId: "main" },
  secondButton: { text: "ارتباط با کارشناسان", modalId: "main" },
  img: "/img/features/management.webp",
};

const secondCardDetails = {
  title: "پنل مدیریتی نواتل، راهکاری برای آسان شدن تنظیمات مرکز تلفن",
  desc: `از امکانات داشبورد اختصاصی نواتل برای افزایش کارایی کارمندان و مدیریت بهتر ارتباطات کسب‌وکارتان با مشتریان، استفاده کنید.`,
  videoImg: {
    img: "/img/features/video.webp",
    video: "/video/dashboard.mp4",
  },
  alt: "کاور پنل مدیریتی نواتل",
}

const thirdCardDetails = [
  {
    id: 1,
    title: "",
    desc: "",
    listThird: [
      {
        id: 0,
        img: "/img/features/management-2.webp",
        title: "گزارشات وضعیت اتصال تماس ها  و عملکرد اپراتورها",
        desc: "در پنل مدیریتی نواتل خود می‌توانید گزارش کلی از تماس‌های وارده و صادره را مشاهده کنید. این گزارش‌ها به بهبود عملکرد ارتباطی سازمان شما کمک می‌کنند و شما می‌توانید برای بهبود این روند، برنامه‌ریزی انجام دهید.",
      },
      {
        id: 1,
        reverse: true,
        img: "/img/features/management-3.webp",
        title: "تنظیم داخلی‌های اختصاصی برای هر اپراتور ",
        desc: "از طریق پنل مدیریتی نواتل می‌توانید برای هر یک از بخش‌های کسب‌وکارتان و هر اپراتور داخلی‌های جداگانه‌ای تعریف کنید و در صورت لزوم در هر ساعتی آنها را تغییر دهید.",
      },
      {
        id: 2,
        full: true,
        title: "ضبط مکالمات ",
        desc: "با استفاده از امکان ضبط مکالمات که در پنل مدیریتی قابل‌تنظیم است، شما می‌توانید به‌تمامی تماس‌های ضبط شده دسترسی داشته باشید. این ویژگی به برطرف کردن مشکلات احتمالی و بالا رفتن حس رضایت مشتریان و آموزش همکاران کمک بسیاری خواهد کرد.",
      },
    ],
  },
];

const forthCardDetails = {
  title: `چه ویژگی‌هایی منجر به علاقه‌مندی کسب‌وکارها به
          پنل مدیریتی نواتل شده است؟`,
  items: [
    {
      id: 0,
      img: "91",
      title: "کاملا ابری و بدون نیاز به سخت افزار",
    },
    { id: 1, img: "44", title: "ایجاد صف تماس" },
    { id: 2, img: "02", title: "ایجاد منشی گویا" },
    { id: 3, img: "11-2", title: "راه‌اندازی صندوق صوتی" },
  ],
};

const lastCardDetails = {
  title: `با ما در ارتباط باشید.`,
  desc: `در صورتی که برای خرید، نصب و راه‌اندازی به مشاوره نیاز دارید با کارشناسان ما در ارتباط باشید.`,

  communicationMethods: [
    {
      id: 0,
      img: "/img/features/method1.webp",
      title: "چت آنلاین",
      link: { text: "گفتگو با ما", href: "" },
    },
    {
      id: 1,
      img: "/img/features/method2.webp",
      title: "ایمیل",
      link: { text: "office@sgas.ir", href: "mailto:office@sgas.ir" },
    },
    {
      id: 2,
      img: "/img/features/method3.webp",
      title: "تماس با پشتیبانی",
      link: { text: "021-82800000", href: "tel:+982182800000" },
    },
  ],
};
</script>

<template>
  <div>
      <BaseTopCard :details="topCardDetails" />
      <BaseSecondCard class="mt-4" :details="secondCardDetails" tag="h2" />
      <BaseThirdCard :items="thirdCardDetails" />
      <BaseForthCard :details="forthCardDetails" />
      <BaseLastCard :details="lastCardDetails" />
  </div>
</template>
